import GeoJSON from 'ol/format/GeoJSON';
import React from 'react';
import {Box} from '@mui/material';
import {object} from 'prop-types';

import Overlay from '../overlay.jsx';
import {MeasureIndicator} from '../measure-indicator.jsx';

const getArrowStyle = theme => {
  const arrowSize = theme.spacing(0.75);
  const border = `${arrowSize} solid ${theme.palette.grey[400]}`;
  const transparentBorder = `${arrowSize} solid transparent`;

  return {
    display: 'inline-block',
    width: theme.spacing(0.5),
    height: theme.spacing(0.5),
    borderRight: border,
    borderTop: transparentBorder,
    borderBottom: transparentBorder,
  };
};

export const MeasureOverlay = ({geometry, mapRef}) => {
  const olGeom = new GeoJSON().readGeometry(geometry);
  const coordinate =
    olGeom.getType() === 'LineString'
      ? olGeom.getCoordinateAt(0.5)
      : olGeom.getInteriorPoint().getLastCoordinate();

  return (
    <Overlay coordinate={coordinate} map={mapRef}>
      <Box display="flex" alignItems="center">
        <Box sx={theme => getArrowStyle(theme)}></Box>
        <Box
          sx={theme => ({
            display: 'flex',
            alignItems: 'center',
            borderRadius: 0.5,
            padding: 1,
            background: theme.palette.grey[400],
          })}
        >
          <MeasureIndicator geometry={geometry} />
        </Box>
      </Box>
    </Overlay>
  );
};

MeasureOverlay.propTypes = {
  geometry: object.isRequired,
  mapRef: object.isRequired,
};
